'use client';
import * as React from 'react';
import { PaletteMode } from '@mui/material';

import { DataModel } from '../Crud';
import { DataSourceCache } from '../Crud/cache';
import { CrudProviderProps } from '../Crud/CrudProvider';
import { Router, Branding, Navigation } from '../AppProvider';
import { DashboardSidebarPageItemContextProps } from '../DashboardLayout/DashboardSidebarPageItem';

export const BrandingContext = React.createContext<Branding | null>(null);

export const NavigationContext = React.createContext<Navigation>([]);

export const PaletteModeContext = React.createContext<{
  isDualTheme: boolean;
  paletteMode: PaletteMode;
  setPaletteMode: (mode: PaletteMode) => void;
}>({
  isDualTheme: false,
  paletteMode: 'light',
  setPaletteMode: () => {},
});

export const RouterContext = React.createContext<Router | null>(null);

export const DashboardSidebarPageItemContext =
  React.createContext<DashboardSidebarPageItemContextProps | null>(null);

export const CrudContext = React.createContext<{
  dataSourceCache: DataSourceCache | null;
  dataSource: CrudProviderProps<DataModel>['dataSource'] | null;
}>({
  dataSource: null,
  dataSourceCache: null,
});

export const WindowContext = React.createContext<Window | undefined>(undefined);
